import { Navigate, useLocation } from "react-router-dom";
import { conRitorno } from "@/lib/ritorno";
import { useAuth, PROFILO, MFA } from "@/contexts/AuthContext";
import { ProfiloNonDisponibile } from "@/components/auth/ErroriDiSistema";

function Schermata({ testId, children }) {
  return (
    <div
      data-testid={testId}
      className="flex min-h-screen items-center justify-center px-page text-center"
    >
      <div className="max-w-sm">{children}</div>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { session, profile, profiloStato, aal, factors, mfaStato, loading, refreshProfile, refreshAal, signOut } = useAuth();
  const dove = useLocation();

  if (loading) {
    return (
      <Schermata testId="auth-loading">
        <p className="text-sm text-muted-foreground">Caricamento…</p>
      </Schermata>
    );
  }

  if (!session) return <Navigate to={conRitorno("/login", dove)} replace />;

  /* Da qui in giù si decide un CANCELLO, e il cancello dipende da due cose che
     arrivano dalla rete: il RUOLO (`profile`) e il SECONDO FATTORE (`aal`,
     `factors`). Tutte e due partono da un valore che sembra una risposta e non
     lo è — `null` e `{ totp: [] }` — e prima venivano lette come un «no»:
       · `profile` nullo → «non è il titolare» → niente cancello TOTP;
       · `aal` nullo    → la verifica di secondo livello non scattava affatto.
     Un dato che non hai non vale «no». Finché non si sa, non si decide. */
  if (profiloStato === PROFILO.IN_CORSO || mfaStato === MFA.IN_CORSO) {
    return (
      <Schermata testId="auth-profilo-in-corso">
        <p className="text-sm text-muted-foreground">Caricamento…</p>
      </Schermata>
    );
  }

  if (profiloStato === PROFILO.NON_DISPONIBILE || mfaStato === MFA.NON_DISPONIBILE) {
    return (
      <ProfiloNonDisponibile
        profilo={profiloStato === PROFILO.NON_DISPONIBILE}
        mfa={mfaStato === MFA.NON_DISPONIBILE}
        // Riprova quello che non è arrivato: il ruolo, il secondo fattore, o tutti e due.
        onRiprova={() => {
          if (profiloStato === PROFILO.NON_DISPONIBILE) refreshProfile?.();
          if (mfaStato === MFA.NON_DISPONIBILE) refreshAal?.();
        }}
        onEsci={() => signOut?.()}
      />
    );
  }

  // TOTP obbligatorio per il titolare — bloccante finché non lo attiva.
  const isTitolare = profile?.ruolo === "titolare";
  const hasVerifiedTotp = (factors?.totp || []).some((f) => f.status === "verified");

  if (isTitolare && !hasVerifiedTotp) {
    return <Navigate to="/auth/totp-enrollment" replace />;
  }

  // Se ha TOTP ma la sessione è ancora aal1, deve completare la challenge.
  if (
    hasVerifiedTotp &&
    aal &&
    aal.currentLevel === "aal1" &&
    aal.nextLevel === "aal2"
  ) {
    return <Navigate to={conRitorno("/auth/totp-verify", dove)} replace />;
  }

  return children;
}
